import React from "react";
import styled from "styled-components";

const FormTitle = ({ children, marginTop, marginBottom, ...props }) => {
  return (
    <Title {...props}>
      {children}
    </Title>
  );
};

const Title = styled.h4`
  color: var(--aia-bx-dark-blue);
  font-size: 16px;
  line-height: 26px;
  margin-top: 0;
  margin-bottom: 0;
`;

export default FormTitle;